import type { DraggableAttributes } from "@dnd-kit/core";
import type { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { GripVertical } from "lucide-react";
import type React from "react";
import "./DragHandle.css";

interface DragHandleProps {
	listeners: SyntheticListenerMap;
	attributes: DraggableAttributes;
}

export const DragHandle: React.FC<DragHandleProps> = ({
	listeners,
	attributes,
}) => {
	return (
		<div {...listeners} {...attributes} className="drag-handle">
			<GripVertical size={14} />
		</div>
	);
};
